module.exports = __webpack_public_path__ + "img/contactImg.ebc87bab.svg";